export interface InverterDesignAssistantArgs {
  inverter_type?: 'string' | 'micro' | 'hybrid' | 'power_optimized'
  manufacturer_name?: string
  codes?: string[]
  limit?: number
}

export interface InverterDesignAssistantResult {
  inverterSets: any[]
  description: string
}

export interface InverterDesignAssistantApiParams {
  orgId: number
  countryIso2: string
  orderByCodes: string[]
  autoStringParams: string
  inverterType?: string
  manufacturerName?: string
  codes?: string[]
  limit: number
}

export async function runInverterDesignAssistantCore(
  args: InverterDesignAssistantArgs,
  systemUuid: string,
  apiCall: (params: InverterDesignAssistantApiParams) => Promise<any[]>
): Promise<InverterDesignAssistantResult> {
  // Get the selected system
  const system = window.editor?.selectedSystem
  if (!system || system.uuid !== systemUuid) {
    throw new Error('No system selected. Please select a system in the design.')
  }

  system.refreshUserData()

  system.moduleGrids().forEach((mg: any) => {
    mg.refreshUserData()
  })

  // Get auto string parameters from the system
  const autoStringParams = window.SceneHelper.autoStringParams(system, null)

  if (!autoStringParams || !autoStringParams.clusters || autoStringParams.clusters.length === 0) {
    throw new Error('No panels found in the system. Please add panels before getting inverter recommendations.')
  }

  // Note: orgId, countryIso2, and orderByCodes should be provided by the caller
  // This function just prepares the auto_string params and calls the provided apiCall function
  const limit = args.limit || 3

  const allInverterSets = await apiCall({
    orgId: 0, // Will be overridden by caller
    countryIso2: '', // Will be overridden by caller
    orderByCodes: [], // Will be overridden by caller
    autoStringParams: JSON.stringify(autoStringParams),
    inverterType: args.inverter_type,
    manufacturerName: args.manufacturer_name,
    codes: args.codes,
    limit: limit,
  })

  if (!Array.isArray(allInverterSets) || allInverterSets.length === 0) {
    throw new Error('No inverter recommendations found for the specified criteria.')
  }

  // Slice to the requested limit (in case API returns more)
  const inverterSets = allInverterSets.slice(0, limit)

  // Build description based on the actual number shown (limited results)
  const description = `Found ${inverterSets.length} recommendation${inverterSets.length > 1 ? 's' : ''}`

  return {
    inverterSets,
    description,
  }
}
